import {useContext} from 'react'

import CheckoutErrorContext from '../components/CheckoutErrorContext'

export default function useCheckoutErrorContext(section?: string) {
  const {error, setError, showAnimation} = useContext(CheckoutErrorContext)

  if (!section) return {}

  return {
    error: error.section === section ? error.error : undefined,
    setError: (error: string) => setError(section, error),
    showAnimation: showAnimation && error.section === section
  }
}
